import { render, staticRenderFns } from "./UserDeactivate.vue?vue&type=template&id=5d36d43f&scoped=true"
import script from "./UserDeactivate.vue?vue&type=script&lang=js"
export * from "./UserDeactivate.vue?vue&type=script&lang=js"
import style0 from "./UserDeactivate.vue?vue&type=style&index=0&id=5d36d43f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d36d43f",
  null
  
)

export default component.exports